// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

import { useRef, useEffect } from "react";
import { getAsset } from "../getAsset";

export function MVPreloader({ show }) {
  let preloader = useRef(null);
  let percentage = useRef(null);

  useEffect(() => {
    if (preloader.current) {
      preloader.current.style.display = show ? "flex" : "none";
    }
  }, [show]);

  let styles = {
    preloader: {
      width: "100%",
      height: "100%",
      position: "absolute",
      left: 0,
      top: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 5,
      background: "#ffffff00",
      backdropFilter: "blur(10px)",
      transition: "backdrop-filter 0.4s ease",
    },
    preloaderBox: {
      position: "relative",
      width: "70%",
      height: "50%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    spinnerContainer: {
      width: "300px",
      height: "200px",
      perspective: "300px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    mvspinner: {
      width: "150px",
      height: "150px",
      position: "relative",
      transformStyle: "preserve-3d",
      animation: "spin 3s infinite linear",
    },
    label: {
      color: "#000000",
    },
  };
  return (
    <div ref={preloader} style={styles.preloader} className="preloader">
      <style>
        {`
          @keyframes spin {
            from { transform: rotateY(0deg); }
            to { transform: rotateY(360deg); }
          }
        `}
      </style>
      <div style={styles.preloaderBox}>
        <div style={styles.spinnerContainer}>
          <div style={styles.mvspinner}>
            <img src={getAsset("logo.svg", "images")} />
          </div>
        </div>
        <div style={styles.label}>Loaded Please Wait . . .</div>
      </div>
    </div>
  );
}
